<chatbot-audio [content]='content'></chatbot-audio>
<chatbot-messages [content]='content'></chatbot-messages>
<chatbot-input [inputEnabled]='content.inputEnabled' [textArea]='content.textArea'
           [inputKind]='content.inputKind' [inputMin]='content.inputMin' [inputMax]='content.inputMax' [inputStep]='content.inputStep'
           [inputRequired]='content.inputRequired' [suggestions]='content.inputSuggestions'
           [content]='content' [placeholder]='content.placeholder' [buttonText]='content.buttonText' [validator]='content.validator'
           [class.enabled]='content.inputEnabled'
></chatbot-input>
